import ElakayImage from '../../../components/images/ElakayImage';
import React from "react";
import { Link } from "react-router-dom";
import { toImageUrl } from "../../../config";
import { elakayAutoText as text } from "../../pageInside/dataElakay";
import { useDropshippingText } from "../i18n";
import { providerStorefrontPath } from "../providerWorkspace";
import "./ui.css";
import { providerShopDisplayName, providerShopMonogram } from "../utils/providerShopIdentity";

// Provider identity card (Home / search "Providers" tab / Seller Sourcing History): logo, shop,
// location, product count, one action. Product actions stay on product cards and the product preview.
// Optional, shown only when the payload carries REAL figures (never a fabricated 0 / rating):
//   entry.rating (+ ratingCount), entry.capabilities { wholesale, dropshipping },
//   onToggleLike (+ entry.isLikedByCurrentSeller, `liking` while the request runs), `extra` (e.g. last viewed).
export default function ProviderCard(props) {
  return <ProviderCompactCard {...props} />;
}

function ProviderCompactCard({ entry, onToggleLike, liking = false, extra = null }) {
  const name = providerShopDisplayName(entry.shop, entry.provider) || "Provider";
  const count = entry.matchedProducts ?? entry.totalProducts;
  const t = useDropshippingText();
  const liked = Boolean(entry.isLikedByCurrentSeller);
  const caps = entry.capabilities;
  return (
    <article className={`provc${onToggleLike ? " provc--likeable" : ""}`}>
      {entry.provider?.avatar ? <ElakayImage preset="avatar-tiny" className="provc__logo" src={toImageUrl(entry.provider.avatar)} alt="" loading="lazy" /> : <span className="provc__logo provc__logo--ph" aria-hidden="true">{providerShopMonogram(entry.shop, entry.provider)}</span>}
      <div className="provc__body">
        <h3>{name}</h3>
        {entry.shop?.location && <p>{entry.shop.location}</p>}
        {Number.isFinite(count) && <p className="provc__count">{count === 1 ? text("h_provc_one", "1 product") : text("h_provc_n", "{value0} products", { value0: count })}</p>}
        {Number.isFinite(entry.rating) && <p className="provc__rating"><span aria-hidden="true">★</span> {entry.rating.toFixed(1)}{Number.isFinite(entry.ratingCount) ? ` (${entry.ratingCount})` : ""}</p>}
        {caps && (caps.wholesale || caps.dropshipping) && (
          <p className="provc__badges">
            {caps.wholesale && <span className="provc__badge">{text("h_provc_wholesale", "Wholesale")}</span>}
            {caps.dropshipping && <span className="provc__badge">{text("h_provc_dropshipping", "Dropshipping")}</span>}
          </p>
        )}
        {extra}
      </div>
      {onToggleLike && (
        <button type="button" className={`provc__like${liked ? " provc__like--on" : ""}`} aria-pressed={liked} disabled={liking}
          aria-label={liked ? text("h_spm_unlikeProvider", "Unlike Provider") : text("h_spm_likeProvider", "Like Provider")} onClick={() => onToggleLike(entry)}>
          <span aria-hidden="true">{liked ? "♥" : "♡"}</span>
        </button>
      )}
      <Link className="provc__btn" to={providerStorefrontPath(entry.provider._id)}>{t("viewProviderShop")}</Link>
    </article>
  );
}

